import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import JoinUs from "./Pages/JoinUs";
import ParkinsonSession from "./Pages/ParkinsonSession";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Blogs from "./Pages/Blogs";
import Events from "./Pages/Events";
import Impact from "./Pages/Impact";
import ImpactStories from "./Pages/ImpactStories";
import Research from "./Pages/Research";
import HealthEquitySupport from "./Pages/HealthEquitySupport";
import YouthEmpowerment from "./Pages/YouthEmpowerment";
import CommunityOutreach from "./Pages/CommunityOutreach";
import ResearchAdvocacy from "./Pages/ResearchAdvocacy";
import InnovationPongAI from "./Pages/InnovationPongAI";
import NotFound from "./Pages/NotFound";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import ChatBot from "./Pages/ChatBot";
import "./Css/App.css";

function RouteBackgroundController() {
  const location = useLocation();

  useEffect(() => {
    const isHome = location.pathname === "/";
    const root = document.documentElement;

    if (isHome) {
      root.classList.add("home-bg");
    } else {
      root.classList.remove("home-bg");
    }

    return () => {
      root.classList.remove("home-bg");
    };
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <div className="app-container">
      <Router>
        <RouteBackgroundController />
        <Header />
        <div className="content-wrap">
          <Routes>
            <Route path="/"                                element={<Home />} />
            <Route path="/Events"                          element={<Events />} />
            <Route path="/Blogs"                           element={<Blogs />} />
            <Route path="/about"                           element={<About />} />
            <Route path="/impact"                          element={<Impact />} />
            <Route path="/impact-stories"                  element={<ImpactStories />} />
            <Route path="/research-advocacy"               element={<ResearchAdvocacy />} />
            <Route path="/research"                        element={<Research />} />
            <Route path="/get-involved/join-us"            element={<JoinUs />} />
            <Route path="/get-involved/parkinson-session"  element={<ParkinsonSession />} />
            <Route path="/programs/ParkinsonSession"         element={<ParkinsonSession />} />
            <Route path="/programs/PingPongParkinson"        element={<ParkinsonSession />} />
            <Route path="/programs/HealthEquitySupport"      element={<HealthEquitySupport />} />
            <Route path="/programs/YouthEmpowerment"         element={<YouthEmpowerment />} />
            <Route path="/programs/CommunityOutreach"        element={<CommunityOutreach />} />
            <Route path="/innovation-pongai"                 element={<InnovationPongAI />} />
            <Route path="/contact"                         element={<Contact />} />
            <Route path="/donate"                          element={<Contact />} />
            <Route path="*"                                element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <ChatBot />
      </Router>
    </div>
  );
}

export default App;